<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <span>学习情况查询</span>
      </div>
    </div>
    <div class="top">
      <el-input class="name"
                v-model="name"
                placeholder="姓名/手机号/单位"></el-input>
      <el-button class="naneBtn"
                 @click="toSearch">搜索</el-button>
      <span class="topt">项目名称：</span>
      <el-select v-model="pid"
                 class="xiangmu"
                 placeholder="请选择项目">
        <el-option v-for="item in nameOptions"
                   :key="item.id"
                   :label="item.proname"
                   :value="item.id">
        </el-option>
      </el-select>
      <span class="topt">完成情况：</span>
      <el-select v-model="learType"
                 class="xiangmu"
                 style="width:150px"
                 placeholder="请选择完成进度">
        <el-option label="不限"
                   :value=0></el-option>
        <el-option label="0%"
                   :value=1></el-option>
        <el-option label="<50%"
                   :value=2></el-option>
        <el-option label="≥50%"
                   :value=3></el-option>
        <el-option label="100%"
                   :value=4></el-option>
      </el-select>
      <el-button class="naneBtn"
                 style="margin-left:30px"
                 @click="daochu">一键导出</el-button>
    </div>
    <div class="listbox">
      <table>
        <thead>
          <tr>
            <th>姓名</th>
            <th>手机号</th>
            <th>单位</th>
            <th>课程明细</th>
            <th>已完成课程数</th>
            <th>课程总数</th>
            <th>学习进度</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in storeList"
              :key="index">
            <td>{{item.userName}}</td>
            <td>{{item.mobile}}</td>
            <td>{{item.unit}}</td>
            <td @click="todetail(item)"
                style="color:#0b8586;cursor: pointer;">查看</td>
            <td>{{item.learnCount}}</td>
            <td>{{item.sumCount}}</td>
            <td>{{Math.ceil(item.learning)}}%</td>
          </tr>
          <tr v-show="storeList.length<1">
            <td colspan="7">暂无账号信息</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="fenye"
         v-show="storeList.length>0">
      <pagination :total="pageCount"
                  :limit="pageSize"
                  :page="pageIndex"
                  style="margin-top:30px"
                  @page-change="pageChange"></pagination>
      <div class="tablesum">共 <span style="color:#0B8586">{{pageCount}}</span> 条</div>
    </div>
    <el-dialog title="课程完成进度明细"
               :visible.sync="isCourseDetails"
               class="Courselist"
               width="856px">
      <el-table :data="mykecheng"
                height="490px"
                border>
        <el-table-column property="title"
                         label="课程名称"></el-table-column>
        <el-table-column label="完成进度"
                         width="100px">
          <template slot-scope="scope">
            <div class="timeBox">
              <span>{{Math.ceil(scope.row.learning*100)}}%</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'usInfor',
  data () {
    return {
      storeName: '',
      name: '',
      pid: '',
      learType: 0,
      storeList: [],
      pageCount: 0,
      pageSize: 10,
      pageIndex: 1,
      nameOptions: [],
      isCourseDetails: false,
      gridData: [],
      pageCount2: 0,
      pageSize2: 10,
      pageIndex2: 1,
      mykecheng: []
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.getProList()
  },
  watch: {
    pid: function () {
      this.pageIndex = 1
      this.getShow()
    },
    learType: function () {
      this.pageIndex = 1
      this.getShow()
    }
  },
  methods: {
    getShow () {
      this.httphelper
        .post('/api/EnterProjectApi/GetOrgItemStudyPageList', {
          proId: this.pid,
          userName: this.name,
          learType: this.learType,
          mobile: '',
          unit: '',
          page: this.pageIndex,
          limit: this.pageSize
        })
        .then(res => {
          if (res.data.code == 200) {
            this.storeList = res.data.data
            this.pageCount = res.data.totalcount
          }
        });
    },
    toSearch () {
      this.pageIndex = 1
      this.getShow()
    },
    getProList () {
      this.httphelper.post('/api/EnterProjectApi/GetEnterProjectPageList', {
        id: Number(localStorage.getItem('storeId')),
        page: 0,
        limit: 99
      })
        .then(res => {
          if (res.data.code == 200) {
            this.nameOptions = res.data.data
            this.pid = res.data.data[0].id
            this.getShow()
          }
        });
    },
    pageChange (page) {
      if (page == this.pageIndex) {
        return;
      }
      this.pageIndex = page;
      this.getShow()
    },
    todetail (item) {
      this.isCourseDetails = true
      this.getMyKecheng(item.userId)
    },
    getMyKecheng (uid) {
      this.httphelper.get('/api/CourseClassApi/GetProgectCourseList', {
        UserId: uid,
        ProId: this.pid,
      })
        .then(res => {
          if (res.code == 200) {
            this.mykecheng = res.data
          }
        });
    },
    daochu () {
      axios({
        // 用axios发送post请求
        method: "post",
        url: "/api/EnterProjectApi/DeriveItemStudyExcel", // 请求地址 ，也可以传递参数
        data: {
          proId: this.pid,
          userName: this.name,
          learType: this.learType,
          mobile: '',
          unit: '',
          page: this.pageIndex,
          limit: this.pageSize
        },
        responseType: "blob" // 表明返回服务器返回的数据类型
      }).then(res => {
        // 处理返回的文件流
        //主要是将返回的data数据通过blob保存成文件
        var content = res.data;
        var blob = new Blob([content]);
        var fileName = "机构成员学习情况.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          // 非IE下载
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });

    }
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    padding-right: 30px;
    margin: 30px 0 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.ttleft {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
}
.top {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}
.name {
    width: 200px;
}
.name ::v-deep .el-input__inner {
    height: 30px;
    padding: 0 10px;
}
.naneBtn {
    height: 30px;
    padding: 6px 10px;
}
.topt {
    margin-left: 30px;
    font-size: 14px;
    color: rgb(121, 121, 121);
}
.xiangmu {
    height: 30px;
}
.xiangmu ::v-deep .el-input__inner {
    height: 30px;
    padding-left: 10px;
}
.xiangmu ::v-deep .el-input__suffix {
    display: flex;
    align-items: center;
}
.listbox {
    width: 100%;
}
.listbox table {
    width: 100%;
    border-collapse: collapse;
}
.listbox th {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    border-color: #e2e2e2;
    border: 1px solid #e2e2e2;
}
.listbox td {
    height: 44px;
    background-color: #0b8586;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    background: #fafafa;
    text-align: center;
    border: 1px solid #e2e2e2;
}
.tablesum {
    width: 80px;
    position: absolute;
    bottom: 16px;
    right: 0px;
    text-align: right;
}
.fenye {
    position: relative;
}
.Courselist ::v-deep .el-dialog {
    padding: 50px 59px;
    height: 640px;
    position: relative;
}
.Courselist ::v-deep .el-dialog__title {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
}
.Courselist ::v-deep .el-dialog__header {
    padding: 0;
}
.Courselist ::v-deep .el-dialog__body {
    height: 100%;
    padding: 0;
    padding-top: 20px;
    box-sizing: border-box;
}
.Courselist ::v-deep th {
    background: #edfafa;
}
.Courselist ::v-deep td,
.Courselist ::v-deep th {
    padding: 8px 0 !important;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
}
</style>